import { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'api/axiosInstance';
import endpoints from 'api/endpoints';

const BrandingContext = createContext({
  companyName: '',
  slug: '',
  customDomain: '',
  logo: null,
  brandColor: '#0D9488',
  loading: true,
  refetch: () => {},
});

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({
    companyName: '',
    slug: '',
    customDomain: '',
    logo: null,
    brandColor: '#0D9488',
    loading: true,
  });

  const fetchBranding = async () => {
    const tenantId = localStorage.getItem('tenant_id');
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');

    // Only fetch for company admins (not SUPER_ADMIN)
    if (!tenantId || !token || role === 'SUPER_ADMIN') {
      setBranding(prev => ({ ...prev, loading: false }));
      return;
    }

    try {
      const response = await axios.get(endpoints.company.updateCompany(tenantId), {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = response.data;
      // Ensure logo URL is absolute (django-storages may return relative path)
      let logoUrl = data.branding_logo || null;
      if (logoUrl && !logoUrl.startsWith('http')) {
        logoUrl = `https://multitenantbackend.s3.amazonaws.com/${logoUrl.replace(/^\/media\//, '')}`;
      }

      setBranding({
        companyName: data.name || '',
        slug: data.slug || '',
        customDomain: data.custom_domain || '',
        logo: logoUrl,
        brandColor: data.branding_colour || '#0D9488',
        loading: false,
      });
    } catch {
      setBranding(prev => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    fetchBranding();
  }, []);

  return (
    <BrandingContext.Provider value={{ ...branding, refetch: fetchBranding }}>
      {children}
    </BrandingContext.Provider>
  );
}

BrandingProvider.propTypes = { children: PropTypes.node };

export const useBranding = () => useContext(BrandingContext);
